Revolution.Module.extend({
    NAME: "mde.anchors", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/anchors.js)
    windowHeight: '',
    gridTop: '',
    gridBottom: '',

    initialize: function ($) {
        //events

        this.windowHeight = $(window).height();
        this.gridTop = this.windowHeight * .3;
        this.gridBottom = this.windowHeight * .6;

        this.initStickyAnchors();
        this.updateAnchors();

    },

    onWindowLoad: function (e) {
        var target = $(window.location.hash);
        if($('body.toolbar-fixed').length) {
            var adjust = $(".page-header-wrapper").height() + 82 + $('#toolbar-bar').height();
        } else {
            var adjust = $(".page-header-wrapper").height() + 82;
        };

        if(target.length) {
            $(window).scrollTop(target.offset().top - adjust)
        };
    },

    onWindowScroll: function (e) {
        this.initStickyAnchors();
        this.updateAnchors();
    },

    onWindowResize: function (e) {

    },

    updateAnchors: function (e) {
        $('.js-bk-bandeau').each(_.bind(function (index, elem) {
            var $bkAnchors = $('.js-bk-anchors');
            var $anchor = $bkAnchors.find('a[href="#' + $(elem).find('.js-bandeau-anchor').attr('id') + '"]');
            var thisTop = $(elem).offset().top - $(window).scrollTop() + 50;
            var content = $anchor.html();

            if (thisTop > this.gridTop && thisTop < this.gridBottom) {
                if (!$anchor.parent().hasClass('active')) {
                    $bkAnchors.find('.active').removeClass('active');
                    $anchor.parent().addClass('active');
                    $('.bk-anchors__btn').html(content);
                }
            } else if (thisTop > this.gridTop && thisTop > this.gridBottom) {
                if ($anchor.parent().hasClass('active')) {
                    $anchor.parent().removeClass('active').prev().addClass('active');
                    $('.bk-anchors__btn').html(content);
                }
            }
        }, this));
    },

    initStickyAnchors: function () {
        if ($('.js-bk-anchors').length) {
            var distanceBeforeTop = ($('.bk-heading').offset().top + $('.bk-heading').innerHeight()) - ($('.page-header-wrapper').height() - $('.header-top').height());
            if ($(window).scrollTop() >= distanceBeforeTop) {
                $('.js-bk-anchors').addClass('sticky');

                if($('body.toolbar-fixed').length) {
                    $('.js-bk-anchors').css('top', $('.page-header-wrapper').height() + $('#toolbar-bar').height());
                } else {
                    $('.js-bk-anchors').css('top', $('.page-header-wrapper').height());
                }
            } else {
                $('.js-bk-anchors').removeClass('sticky');
                $('.js-bk-anchors').removeAttr('style');
            }
        };
    },
});
